export default {
    getStudies(axios) {
        return axios({
            url: `studies`,
            method: 'GET'
        })
    },
    getActiveStudies(axios) {
        return axios({
            url: `studies/active`,
            method: 'GET'
        })
    },
    getScores(axios) {
        return axios({
            url: `scores`,
            method: 'GET'
        })
    },
    get(id, axios) {
        return axios({
            url: `studies/${id}/view`,
            method: 'GET'
        })
    },
    export(id, axios) {
        return axios({
            url: `studies/${id}/export`,
            method: 'GET',
            responseType: 'blob'
        })
    },
    add(patientData, axios) {
        return axios({
            url: `studies/add`,
            method: 'POST',
            data: patientData
        })
    },
    update(id, patientData, axios) {
        return axios({
            url: `studies/${id}/update`,
            method: 'POST',
            data: patientData
        })
    },
    delete(id, axios) {
        return axios({
            url: `studies/${id}/delete`,
            method: 'POST'
        })
    },
    getFollowUp(id, idFollowUp, axios) {
        return axios({
            url: `studies/${id}/followup/${idFollowUp}`,
            method: 'GET'
        })
    },
    addFollowUp(id, data, axios) {
        return axios({
            url: `studies/${id}/followup/add`,
            method: 'POST',
            data: data
        })
    },
    updateFollowUp(id, idFollowUp, data, axios) {
        return axios({
            url: `studies/${id}/followup/${idFollowUp}/update`,
            method: 'POST',
            data: data
        })
    },
    deleteFollowUp(id, idFollowUp, axios) {
        return axios({
            url: `studies/${id}/followup/${idFollowUp}/delete`,
            method: 'POST'
        })
    },
    toggleBlockNewPatient(id, axios) {
        return axios({
            url: `studies/${id}/toggle-block-new-patient`,
            method: 'PUT'
        })
    }
}
